import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faHandHoldingDollar, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { Link } from "react-router-dom";
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';

function GetLoan() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
    const r = await getRate(currencyCode);
    if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [loanOffer, setLoanOffer] = useState([]);
    useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchoffer: true })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          setLoanOffer(data.offers);
        }
      })
      .catch(err => {
      })
    }, [user]);
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Get a Loan" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Get a Loan" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="mb-4 mt-3">
                <h5 className="mb-0" style={{fontWeight:'900',lineHeight:'120%'}}>Loan Application</h5>
                <p className="mb-0" style={{fontSize:'14px'}}><Link to="/loan" className="noLink text-prime fw-semibold">Loan</Link> <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} /> Select Type</p>
            </div>
            <p className="mb-0 text-center" style={{fontWeight:'900',fontSize:'18px'}}>Choose Your Loan Type</p>
            <p className="mb-0 text-center" style={{fontSize:'14px'}}>Select the type of loan that best fits your needs</p>
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2">
                        <div className="row">
                            {loanOffer.map((loan) => (
                            <div className="col-md-6 g-4">
                                <div className="mycard shadow p-3 pb-5">
                                    <div className="d-flex" style={{gap:'20px'}}>
                                        <div className="d-flex align-items-cenetr jusitfy-content-center overflow-hidden rounded-circle" style={{height:'35px',width:'35px',minHeight:'35px',minWidth:'35px'}}>
                                            <img src={`/uploads/${loan.photo}`} alt="profile" className="w-100 h-100" style={{objectFit: 'cover'}}/>
                                        </div>
                                        <div>
                                            <p className="mb-0 fw-bold text-prime" style={{fontSize:'14px'}}>{loan.title}</p>
                                            <p className="mb-0" style={{fontSize:'12px',lineHeight:'120%'}}>{loan.descr}</p>
                                            <div className="d-flex align-items-center justify-content-between mt-2">
                                                <p className="mb-0 fw-bold text-success" style={{fontSize:'12px'}}>Up to {getCurrencySymbol(user?.currency)}{formatCurrency(loan.max * rate)}</p>
                                                <p className="mb-0 text-prime" style={{fontSize:'12px'}}>Starting from {loan.rate}%</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end mt-2">
                                      { Number(user?.credit_score) > 740 ?
                                        (
                                          <Link to="/loanform" state={{loan_id: loan.loan_id,casset: 'Bitcoin', collateral: 0, collat : 'BTC'}} className="myBtn rounded-pill px-3 py-2 fw-semibold text-center" style={{fontSize:'12px'}}>Get Loan <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '10px'}} /></Link>
                                        ) : (  
                                          <Link to="/loandetails"
                                          onClick={() => {
                                            localStorage.setItem('deposit.loanID', loan.loan_id);
                                            localStorage.setItem('deposit.takeLoan', true);
                                          }}
                                          className="myBtn rounded-pill px-3 py-2 fw-semibold text-center" style={{fontSize:'12px'}}>Get Loan <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '10px'}} /></Link> 
                                        )
                                      }
                                    </div>
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default GetLoan